import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spin, message, Empty, Alert, Modal } from 'antd';
import { reportAPI } from '../services/api';
import { isGuestUser, getGuestReports } from '../utils/guestUser';
import './HistoryPage.css';

const HistoryPage = ({ currentUser, setCurrentUser }) => {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      message.warning('请先登录或使用游客模式');
      navigate('/');
      return;
    }
    fetchReports();
  }, [currentUser, navigate]);

  const fetchReports = async () => {
    try {
      // 如果是游客，从localStorage读取
      if (isGuestUser(currentUser)) {
        const guestReports = getGuestReports();
        setReports(guestReports);
      } else {
        // 正式用户从服务器读取
        const response = await reportAPI.getUserReports(currentUser.id);
        setReports(response.data.reports);
      }
    } catch (error) {
      message.error('获取历史报告失败');
      console.error('获取报告错误:', error);
    } finally {
      setLoading(false);
    }
  };

  // 游客升级 - 引导返回首页并自动打开注册弹窗
  const handleUpgradeToUser = () => {
    Modal.confirm({
      title: '注册账号',
      content: '注册后可永久保存所有检测数据，并在任何设备上查看。是否返回首页注册？',
      okText: '返回首页注册',
      cancelText: '继续游客体验',
      onOk: () => {
        navigate('/?action=register');
      }
    });
  };

  const handleViewReport = (reportId) => {
    navigate(`/result/${reportId}`);
  };

  if (loading) {
    return (
      <div className="container">
        <div className="page-wrapper">
          <Spin size="large" tip="加载中..." />
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return null;
  }

  return (
    <div className="container">
      <div className="page-wrapper history-page">
        <h1 className="page-title">历史检测报告</h1>

        {isGuestUser(currentUser) && reports.length > 0 && (
          <Alert
            message="游客模式数据"
            description={
              <div>
                <p>您当前查看的是浏览器本地保存的报告（最多保存10条）。</p>
                <p>
                  <strong>注册账号</strong>可永久保存所有检测数据，并在任何设备上查看。
                  <a onClick={handleUpgradeToUser} style={{ marginLeft: '8px', cursor: 'pointer', color: '#b8860b' }}>
                    立即注册 →
                  </a>
                </p>
              </div>
            }
            type="info"
            showIcon
            closable
            style={{ marginBottom: '24px' }}
          />
        )}

        {reports.length === 0 ? (
          <div className="empty-state">
            <Empty 
              description="暂无检测记录"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
            <button 
              className="button-primary" 
              onClick={() => navigate('/detection')}
              style={{ marginTop: '24px', maxWidth: '300px' }}
            >
              开始检测
            </button>
          </div>
        ) : (
          <>
            <div className="reports-summary">
              <div className="summary-item">
                <div className="summary-value">{reports.length}</div>
                <div className="summary-label">总检测次数</div>
              </div>
              <div className="summary-item">
                <div className="summary-value">
                  {reports[0]?.body_type || '-'}
                </div>
                <div className="summary-label">最新体质</div>
              </div>
            </div>

            <div className="reports-list">
              {reports.map((report, index) => (
                <div 
                  key={report.id} 
                  className="report-item"
                  onClick={() => handleViewReport(report.id)}
                >
                  <div className="report-number">#{reports.length - index}</div>
                  <div className="report-content">
                    <div className="report-body-type">
                      <span className="body-type-badge">{report.body_type}</span>
                    </div>
                    <div className="report-soup">
                      推荐：{report.recommended_soup}
                    </div>
                    <div className="report-date">
                      {new Date(report.created_at).toLocaleString('zh-CN', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </div>
                  </div>
                  <div className="report-arrow">›</div>
                </div>
              ))}
            </div>
          </>
        )}

        <div className="button-group">
          <button className="button-primary" onClick={() => navigate('/detection')}>
            再次检测
          </button>
          <button className="button-secondary" onClick={() => navigate('/')}>
            返回首页
          </button>
        </div>
      </div>
    </div>
  );
};

export default HistoryPage;

